/* global axios */
import ApiClient from 'dashboard/api/ApiClient';

// Pixta's help desk tools (custom/docs/PIXTA.md): the account's connection and the customer of a conversation
class PixtaAPI extends ApiClient {
  constructor() {
    super('loco/pixta', { accountScoped: true });
  }

  connection() {
    return axios.get(`${this.url}/connection`);
  }

  updateConnection(payload) {
    return axios.patch(`${this.url}/connection`, payload);
  }

  deleteConnection() {
    return axios.delete(`${this.url}/connection`);
  }

  testConnection() {
    return axios.post(`${this.url}/connection/test`);
  }

  customerUrl(conversationId) {
    return `${this.url}/conversations/${conversationId}/customer`;
  }

  customer(conversationId, signal) {
    return axios.get(this.customerUrl(conversationId), { signal });
  }

  search(conversationId, query) {
    return axios.post(`${this.customerUrl(conversationId)}/search`, { query });
  }

  link(conversationId, userId) {
    return axios.post(`${this.customerUrl(conversationId)}/link`, {
      user_id: userId,
    });
  }

  unlink(conversationId) {
    return axios.delete(`${this.customerUrl(conversationId)}/link`);
  }

  resendTickets(conversationId, orderId) {
    return axios.post(
      `${this.customerUrl(conversationId)}/orders/${orderId}/resend_tickets`
    );
  }

  cancelOrder(conversationId, orderId) {
    return axios.post(
      `${this.customerUrl(conversationId)}/orders/${orderId}/cancel`
    );
  }
}

export default new PixtaAPI();
